/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ added: NonNullable<unknown>, removed: NonNullable<unknown>, swapped: NonNullable<unknown>, changed: NonNullable<unknown> }} Today_Draft_Counts_LabelInputs */

const en_us2_today_draft_counts_label = /** @type {(inputs: Today_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} in, ${i?.removed} out, ${i?.swapped} swaps, ${i?.changed} adjustments`)
};

const pt_br2_today_draft_counts_label = /** @type {(inputs: Today_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} entram, ${i?.removed} saem, ${i?.swapped} trocas, ${i?.changed} ajustes`)
};

const es_419_today_draft_counts_label = /** @type {(inputs: Today_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} entran, ${i?.removed} salen, ${i?.swapped} cambios, ${i?.changed} ajustes`)
};

const pt_pt2_today_draft_counts_label = /** @type {(inputs: Today_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} entram, ${i?.removed} saem, ${i?.swapped} trocas, ${i?.changed} ajustes`)
};

const fr_fr2_today_draft_counts_label = /** @type {(inputs: Today_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} ajouts, ${i?.removed} retraits, ${i?.swapped} remplacements, ${i?.changed} ajustements`)
};

const de_de2_today_draft_counts_label = /** @type {(inputs: Today_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} neu, ${i?.removed} entfernt, ${i?.swapped} getauscht, ${i?.changed} angepasst`)
};

const it_it2_today_draft_counts_label = /** @type {(inputs: Today_Draft_Counts_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} aggiunti, ${i?.removed} tolti, ${i?.swapped} sostituzioni, ${i?.changed} modifiche`)
};

/**
* | output |
* | --- |
* | "{added} in, {removed} out, {swapped} swaps, {changed} adjustments" |
*
* @param {Today_Draft_Counts_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_draft_counts_label = /** @type {((inputs: Today_Draft_Counts_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Draft_Counts_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_draft_counts_label(inputs)
	if (locale === "es-419") return es_419_today_draft_counts_label(inputs)
	if (locale === "pt-PT") return pt_pt2_today_draft_counts_label(inputs)
	if (locale === "fr-FR") return fr_fr2_today_draft_counts_label(inputs)
	if (locale === "de-DE") return de_de2_today_draft_counts_label(inputs)
	if (locale === "it-IT") return it_it2_today_draft_counts_label(inputs)
	return en_us2_today_draft_counts_label(inputs)
});
export { today_draft_counts_label as "today.draft_counts_label" }